import { ContextMenuIcon } from 'features/common/ui/ContextMenu'
import { Integration } from 'features/integrations/types'
import MoreIcon from 'assets/icons/icon-navigation-more-vert.svg?react'
import { useCallback, useMemo } from 'react'
import { useTheme } from '@mui/material'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

function IntegrationExternalIdpContextMenu({ integration }: { integration: Integration }) {
  const theme = useTheme()
  const intl = useIntl()
  const navigate = useNavigate()

  const onClickMenuItem = useCallback(
    ({ id }) => {
      switch (id) {
        case 'edit':
          navigate(`externalIdp/${integration.id}`)
          break
        default:
      }
    },
    [navigate, integration.id]
  )

  const actions = useMemo(
    () => [
      {
        id: 'edit',
        label: intl.formatMessage({ id: 'common.actions.edit' })
      }
    ],
    [intl]
  )

  return (
    <>
      <ContextMenuIcon
        aria-label="Integrations actions"
        menuItems={actions}
        placement="bottom-end"
        onClickItem={onClickMenuItem}
        alignRight={true}
      >
        <MoreIcon fill={theme.palette.text.secondary} />
      </ContextMenuIcon>
    </>
  )
}

export default IntegrationExternalIdpContextMenu
